/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Image from '@/components/image';
import Button from '@/components/button';
import Tags from '@/components/blog/tags';
import Article from '@/libraries/article';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useRef } from 'react';
import { useTranslations } from 'next-intl';

//Load Module
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function Featured({ children, article, ...props }){

	//Get the Translations
	const t = useTranslations();
	const ref = useRef();

	//GSAP
	useGSAP(()=>{

		//The Container
		const $container  = ref.current,
			timeline    = gsap.timeline({
				scrollTrigger: {
					trigger:                $container,
					invalidateOnRefresh:    true,
					scrub:                  true,
					start:                  'top center',
					end:                    () => `+=${  $container.offsetHeight }`
				}
			});

		//Initiate
		timeline.fromTo( 'img' , { scale: 1 } , { scale: 1.2 } );

	},{ scope: ref });

	//Return
	return (
		<section id="featured" className="container">
			<article ref={ ref }>
				<div>
					<div>
						<Tags article={ article } type="dark" />
						<h2>{ article.title }</h2>
						<p>{ Article.excerpt( article ) }</p>
						<Button href={ `/blog/${  article.blog.handle  }/${  article.handle }` } size="small" type="white">
							{ t('Pages.Blog.read-more') }
						</Button>
					</div>
				</div>
				<Image src={ article?.image?.url || '' } alt="" fill />
			</article>
		</section>
	);

}